<template>
  <div>
    <el-dialog title="参考酒店分享" :visible.sync="dialogVisible" width="50%" :append-to-body="true">
      <div>
        <div v-for="(item,index) in list" :key="index" class="referHotelImage">
          <p style="font-weight: bold;">{{item.dateRangeStrAndCityName}}</p>
          <div v-for="(item1,index1) in item.groupReferenceHotelSons" :key="index1">
            <p style="font-weight: bold;">{{item1.hotelNameAndStar}}</p>
            <p v-for="(item2,index2) in item1.roomInfo" :key="index2" style="display: flex;align-items: center;">
              <i class="el-icon-thumb" style="font-size: 0.19rem;transform: rotate(90deg);"></i>
              <span>&nbsp;{{item2.name}}</span>
              <el-input v-if="isEdit" v-model="item2.price" placeholder="请输入新的报价" style="width:1.3rem" size="mini"></el-input>&nbsp;
              <i v-if="isEdit" @click="deleteArrData(item1.roomInfo,item2,index2)" class="el-icon-remove-outline" style="font-size: 0.19rem;"></i>
            </p>
            <p>{{item1.vatAndCityTax}}</p>
            <p style="color:red;font-weight: bold;">
              <span v-if="!isEdit">Option:{{item1.option}}</span>
              <el-date-picker v-else v-model="item1.option" format="yyyy-MM-dd HH" type="datetime" 
                placeholder="请输入option时间" style="width: 1.7rem;" value-format="yyyy-MM-dd HH"/>
            </p>
            <p>{{item1.cancelStr}}</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">{{isEdit?'保存':'编辑'}}</el-button>
        <el-button type="primary" @click="exportWord" v-loading.fullscreen.lock="fullscreenLoading">word导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
export default {
  data(){
    return{
      dialogVisible:false,
      fullscreenLoading:false,
      budgetMainId:null,
      list:[],
      isEdit:false,
      deleteArr:[],
    }
  },
  methods:{
    deleteArrData(arr,item,index){
      arr.splice(index,1)
      this.deleteArr.push(item)
    },
    save(){
      if(!this.isEdit){
        this.isEdit = true
      }else{
        var updateArr=[]
        var updateArrLink=[]
        var deleteArr1=[]
        var deleteArrLink=[]
        this.deleteArr.forEach(e=>{
          var obj = {
            budgetDetailIds:e.budgetDetails,
          }
          if(e.type==1){
            deleteArrLink.push(obj)
          }else{
            deleteArr1.push(obj)
          }
        })
        this.list.forEach(e=>{
          e.groupReferenceHotelSons.forEach(ee=>{
            ee.roomInfo.forEach(eee=>{
              if(eee.price||ee.option){
                var obj = {
                  budgetDetailIds:eee.budgetDetails,
                  ratio:eee.price,
                  optionDate:ee.option+":00:00"
                }
                if(eee.type==1){
                  updateArrLink.push(obj)
                }else{
                  updateArr.push(obj)
                }
              }
            })
          })
        })
        new PlanApi("plan").referenceHotelDataUpdate({
          budgetMainId:this.budgetMainId,
          updateArr:updateArr,
          updateArrLink:updateArrLink,
          deleteArr:deleteArr1,
          deleteArrLink:deleteArrLink
        }).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"保存成功"})
            this.isEdit = false
            if(updateArr.length>0||updateArrLink.length>0){
              this.refresh()
            }
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }
    },
    refresh(){
      this.deleteArr = []
      new PlanApi("plan").referenceHotelList({budgetMainId:this.budgetMainId}).then(res => {
        this.list = res.data
        this.list.forEach(e=>{
          e.groupReferenceHotelSons.forEach(ee=>{
            ee.roomInfo.forEach(eee=>{
              this.$set(eee,'price',null)
            })
          })
        })
      })
    },
    openDialog(budgetMainId){
      this.budgetMainId = budgetMainId
      this.dialogVisible = true
      this.refresh()
    },
    exportWord(){
      this.fullscreenLoading = true
      new PlanApi("plan").referenceHotelExport(this.budgetMainId, "参考酒店", ".docx").then(res => {
        this.fullscreenLoading = false
        this.dialogVisible  =false
        this.$emit("closeDialog")
      }).catch(() => {
        this.$message.error("系统异常")
        this.fullscreenLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.referHotelImage{
  p{
    margin-bottom: 0.1rem;
  }
}
</style>